import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-no-trains-found-component',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './no-trains-found-component.component.html',
  styleUrls: ['./no-trains-found-component.component.scss']
})
export class NoTrainsFoundComponentComponent {

}
